import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { closeRegisterModal } from "@store/features/userActionsSlice";
import { useStyleSchema } from "@components/styleSchema/StyleSchemaHandler";
import clsx from "clsx";
import { RegistrationSuccess } from "./RegistrationSuccess";
import { PersonalInfoSection } from "./sections/PersonalInfoSection";
import { AddressSection } from "./sections/AddressSection";
import { AccountSection } from "./sections/AccountSection";
import { TermsSection } from "./sections/TermsSection";
import { useRegisterForm } from "./hooks/useRegisterForm";
import { ROUTES } from "@constants/routes";
export default function RegisterFormComponent() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentSchema } = useStyleSchema();
  const buttonColor = currentSchema.colors?.primary?.hex;
  
  const {
    control,
    handleSubmit,
    onSubmit,
    errors,
    isLoading,
    showSuccessMessage,
    privacyAccepted,
    marketingAccepted,
    showPassword,
    showConfirmPassword,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility,
    handleTermsToggle,
    handlePrivacyToggle,
    isFormValid,
  } = useRegisterForm();

  const navigateToAccount = () => {
    dispatch(closeRegisterModal());
    
    // Nach Registrierung direkt zu My Account navigieren
    // Keine komplexe Redirect-Logik, da der User gerade registriert wurde und ein Kunde ist
    window.location.href = ROUTES.myAccount;
  };

  return (
    <div className="relative w-full">
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { transform: scale(0); }
          to { transform: scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out forwards;
        }
        .animate-scaleIn {
          animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
          animation-delay: 0.2s;
          opacity: 0;
          animation-fill-mode: forwards;
        }
      `}</style>
      
      {!showSuccessMessage ? (
        <form
          onSubmit={handleSubmit((data) => {
            onSubmit(data);
          })} 
          className="space-y-4 w-full"
        >
          <PersonalInfoSection control={control} />
          <AddressSection control={control} />
          <AccountSection
            control={control}
            showPassword={showPassword}
            showConfirmPassword={showConfirmPassword}
            togglePasswordVisibility={togglePasswordVisibility}
            toggleConfirmPasswordVisibility={toggleConfirmPasswordVisibility}
          />
          <TermsSection
            control={control}
            marketingAccepted={marketingAccepted}
            privacyAccepted={privacyAccepted}
            handleTermsToggle={handleTermsToggle}
            handlePrivacyToggle={handlePrivacyToggle}
            errors={errors}
          />

          {/* Submit Button */}
          <div className="w-full flex justify-center mt-8 gap-4">
            <button
              type="submit"
              className={clsx("px-4 py-2 rounded text-center md:w-auto disabled:opacity-50 disabled:cursor-not-allowed", {
                "flex items-center gap-2": isLoading,
              })}
              style={{
                background: buttonColor,
                color: "white",
              }}
              disabled={!isFormValid || !privacyAccepted || isLoading}
            >
              {isLoading ? (
                <>
                  <span className="mr-2">{t("register.buttons.registering")}</span>
                  <div className="animate-spin h-4 w-4 border-2 border-white rounded-full border-t-transparent"></div>
                </>
              ) : (
                t("register.buttons.register")
              )}
            </button>
          </div>
          <p className="text-sm text-slate-600">{t("app.requiredFields")}</p>
        </form>
      ) : (
        <div className="w-full animate-fadeIn">
          <RegistrationSuccess onNavigateToAccount={navigateToAccount} />
        </div>
      )}
    </div>
  );
}